import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import CashButton from "../../../sale/cashbtn";
import PayLaterButton from "../../../sale/PaylaterBtn";
import QRCode from "qrcode";
import { formatCurrency } from "@heartinz/finance";
import { FormatedSaleData } from "../../../../../utils/print/GlobelSaleData";
import { DownloadIcon, PrinterIcon, ShowIcon } from "../../../../../constants/Icons";
const HalfA4_3 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  payment = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const { isUser, settings } = useAuth();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [error, setErrors] = useState({});
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
  const cashRef = useRef();
  const paylaterRef = useRef();
  const globalData = FormatedSaleData(data);
  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
  const formatCurrencyINR = (value) => {
    const formatted = Math.abs(value).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  // new template starts ////// **/////////////////////////////

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");

  const generateinvoiceHalfA4PDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const HALF_PAGE_HEIGHT = 140;
    const PADDING = 5;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const centerX = pageW / 2;
    let y = PADDING; // Starting height

    if (globalData?.salefrom?.image) {
      try {
        const imagePath = settings?.saleProfileData?.image
          ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
          : "/assets/images/logo-light.png";
        const logoBase64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(logoBase64);
        // 1. DRAW LOGO (Far Left)
        const maxWidth = 30;
        const maxHeight = 12;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalW = width * ratio;
        const finalH = height * ratio;

        doc.addImage(logoBase64, "PNG", MARGIN_LEFT, y, finalW, finalH);
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(8);
        doc.setTextColor(100);
        doc.text("TAX INVOICE", centerX, y + 3, { align: "center" });

        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(10);
        doc.setTextColor(0);
        doc.text(
          globalData.salefrom?.title?.toUpperCase() || "",
          centerX,
          y + 8,
          { align: "center" }
        );

        doc.setFontSize(7);
        doc.setTextColor(0);

        // Invoice No Row

        const invLabel = "Invoice No. ";
        const invVal = globalData.saleno || "-";
        const invDateTime = DateConverter.ISOToDisplayFormat(
          DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone)
        ).time;
        const dateStr = `DATE: ${
          globalData.saledate
            ? DateConverter.ISOToDisplayFormat(globalData.saledate).date
            : "-"
        }  `;
        const timeStr = `TIME: ${invDateTime || ""}`;
        const invValW = doc.getTextWidth(invVal);
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          invLabel,
          MARGIN_RIGHT - invValW - doc.getTextWidth(invLabel),
          y + 2
        );
        doc.setFont("Inter-Bold", "bold");
        doc.text(invVal, MARGIN_RIGHT, y + 2, { align: "right" });
        const totalDateTimeWidth =
          doc.getTextWidth(dateStr) + doc.getTextWidth(timeStr);

        const lineStartX = MARGIN_RIGHT - totalDateTimeWidth - 1; // Adjust this number to make the line longer/shorter
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor); // Light grey color
        doc.setLineWidth(0.1);
        doc.line(lineStartX, y + 3.5, MARGIN_RIGHT, y + 3.5);

        const timeStrW = doc.getTextWidth(timeStr);
        doc.setFont("Inter-Regular", "normal");
        doc.text(dateStr, MARGIN_RIGHT - timeStrW - 1, y + 6, {
          align: "right",
        });
        doc.text(timeStr, MARGIN_RIGHT, y + 6, { align: "right" });

        let addrY = y + finalH + 4; // Move down below logo/title area
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(60, 60, 60);
        let currentTextY = addrY;
        const addrLine1 = [
          globalData.salefrom?.addressline1,
          globalData.salefrom?.addressline2,
        ]
          .filter(Boolean)
          .join(", ");
        const addrLine2 = [
          globalData.salefrom?.district,
          globalData.salefrom?.state,
          globalData.salefrom?.pincode,
        ]
          .filter(Boolean)
          .join(", ");
        const contactLine = `Ph: ${globalData.salefrom?.phone || ""}  GSTIN: ${
          globalData.salefrom?.gstnumber || ""
        }`;

        if (addrLine1.trim()) {
          doc.text(addrLine1, MARGIN_LEFT, currentTextY);
          currentTextY += 3;
        }
        if (addrLine2.trim()) {
          doc.text(addrLine2, MARGIN_LEFT, currentTextY);
          currentTextY += 3;
        }
        // const contactY = addrY + 6;
        let currentX = MARGIN_LEFT;
        const phone = globalData.salefrom?.phone;
        const gstin = globalData.salefrom?.gstnumber;

        if (phone || gstin) {
          doc.setFont("Inter-Bold", "bold");
          doc.text("Ph:", currentX, currentTextY);
          currentX += doc.getTextWidth("Ph: ");

          doc.setFont("Inter-Regular", "normal");
          doc.text(
            `${globalData.salefrom?.phone || ""}  `,
            currentX,
            currentTextY
          );
          currentX += doc.getTextWidth(`${phone || ""}  `);

          doc.setFont("Inter-Bold", "bold");
          doc.text("GSTIN:", currentX, currentTextY);
          currentX += doc.getTextWidth("GSTIN: ");

          doc.setFont("Inter-Regular", "normal");
          doc.text(`${gstin || ""}`, currentX, currentTextY);
          // doc.text(contactLine, MARGIN_LEFT, addrY + 6);
        }
        y = currentTextY + 2;
      } catch (e) {
        console.warn("Header layout failed", e);
        y += 15;
      }
    }

    y += 1;

    if (globalData.saleto) {
      let rowHeight = 5; // Adjusted to fit address + padding
      doc.setDrawColor(
        selectedTheme?.templateTheme?.borderColor || [200, 200, 200]
      );
      doc.setLineWidth(0.2);
      // doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);

      // 2. LEFT SIDE: "Customer Details :" and Customer Address
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Customer Details :", MARGIN_LEFT + 2, y + 3.5);

      doc.setFontSize(8);
      doc.setFont("Inter-Regular", "normal");
      doc.text(globalData.saleto?.name || "", MARGIN_LEFT + 2, y + 7);
      rowHeight += 4;
      const fullAddress = [
        globalData.saleto?.addressline1,
        globalData.saleto?.addressline2,
        globalData.saleto?.district,
        globalData.saleto?.state,
      ]
        .filter(Boolean)
        .join(", ");
      const pinCode = globalData.saleto?.pincode
        ? ` - ${globalData.saleto.pincode}`
        : "";
      if (fullAddress || pinCode) {
        const wrappedAddr = doc.splitTextToSize(
          fullAddress + pinCode,
          pageW / 2 + 10
        );
        doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 10.5);
        rowHeight += wrappedAddr.length * 3;
      }
      const mrpStartX = MARGIN_LEFT + 142;
      doc.line(mrpStartX, y, mrpStartX, y + rowHeight);
      // Phone
      const rightSectionStart = mrpStartX + 2;
      doc.setFont("Inter-Bold", "bold");
      const phLabel = "Ph: ";
      const phVal = globalData.saleto?.phone || "";

      doc.text(phLabel, rightSectionStart, y + 3.5);
      doc.setFont("Inter-Regular", "normal");
      doc.text(phVal, rightSectionStart + doc.getTextWidth(phLabel), y + 3.5);

      // GSTIN
      doc.setFont("Inter-Bold", "bold");
      const gstLabel = "GSTIN: ";
      const gstVal = globalData.saleto?.gstnumber || "";

      doc.text(gstLabel, rightSectionStart, y + 7);
      doc.setFont("Inter-Regular", "normal");
      doc.text(gstVal, rightSectionStart + doc.getTextWidth(gstLabel), y + 7);
      // Update Y for the next section (Table)
      doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
      y += rowHeight;
    }
    /* -------------------------------------------------
     PRODUCT TABLE1
  ------------------------------------------------- */
    const rowCount = globalData?.saleitems?.length;
    // Set a default minimum height for the whole table body area (e.g., 60mm)
    // const totalBodyHeight = rowCount > 3 ? 0 : 60;
    // const dynamicMinHeight = rowCount > 0 ? totalBodyHeight / rowCount : 0;
    const standardHeight = 4;
    const targetTotalHeight = 40;
    const extraSpace =
      rowCount > 0 && rowCount <= 5
        ? targetTotalHeight - rowCount * standardHeight
        : 0;
    autoTable(doc, {
      startY: y,
      theme: "plain",
      rowPageBreak: "avoid",
      margin: {
        top: PADDING,
        left: PADDING,
        right: PADDING,
        bottom: pageH - HALF_PAGE_HEIGHT + PADDING,
      },
      styles: {
        font: "Inter-Regular",
        fontSize: 6.5,
        cellPadding: 1.5,
        valign: "top",
        lineWidth: 0, // No default borders
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 7,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], // Pink like image
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        lineWidth: 0.2,
        lineColor: selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      },
      bodyStyles: {
        minCellHeight: Math.max(2, standardHeight),
      },
      head: [["#", "ITEM", "RATE", "QTY", "LANDING COST", "Tax Val", "AMOUNT"]],
      body: globalData?.saleitems.map((it, i) => [
        i + 1,
        it.hsnsac ? `${it.title}\nHSN: ${it.hsnsac}` : it.title,

        `₹${it.baseprice}`,
        `${it.quantity} ${(() => {
          const unitCode = it?.isSecondaryUnit
            ? it?.unitConfig?.secondaryUnitCode
            : it?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`,
        `₹${it?.lineTotalLandingCost}`,
        `₹${it.lineTotalBasePrice}`,
        `₹${it.lineGrandTotal}`,
      ]),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: "auto", halign: "left" },
        2: { cellWidth: 15, halign: "right" },
        3: { cellWidth: 11, halign: "center" },
        4: { cellWidth: 16, halign: "right" },
        5: { cellWidth: 16, halign: "right" },
        6: { cellWidth: 16, halign: "right" },
      },
      didParseCell: function (data) {
        if (data.section === "head") {
          const colId = data.column.index;
          if (colId === 0 || colId === 3) data.cell.styles.halign = "center";
          if (colId === 2 || colId === 4 || colId === 5 || colId === 6)
            data.cell.styles.halign = "right";
        }
        if (data.section === "body") {
          data.cell.styles.lineWidth = {
            left: 0.1,
            right: 0.1,
            top: 0,
            bottom: 0,
          };
          data.cell.styles.lineColor = selectedTheme?.templateTheme
            ?.borderColor || [200, 200, 200]; // Black vertical lines
          if (data.row.index === rowCount - 1) {
            data.cell.styles.minCellHeight = standardHeight + extraSpace;
          }
          if (data.row.index === rowCount - 1) {
            data.cell.styles.lineWidth.bottom = 0.1;
          }
        }
      },
      didDrawPage: function (data) {
        const finalY = data.cursor.y;
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
      },
    });

    const finalY = doc.lastAutoTable.finalY;
    const borderColor = selectedTheme?.templateTheme?.borderColor || [
      200, 200, 200,
    ];
    const rowH = 5;
    doc.setDrawColor(borderColor);
    doc.setLineWidth(0.1);

    // --- 1. COORDINATES ---
    const rightSectionWidth = 58;
    const amountWidth = 16;
    const totalLabelX = MARGIN_RIGHT - rightSectionWidth;
    const totalValueX = MARGIN_RIGHT - amountWidth;

    // --- 2. TOP ROW: IN WORDS & TOTAL ---
    doc.rect(PADDING, finalY, pageW - PADDING * 2, rowH);
    doc.line(totalLabelX, finalY, totalLabelX, finalY + rowH);
    doc.line(totalValueX, finalY, totalValueX, finalY + rowH);

    let textY = finalY + rowH / 2 + 1;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(7);
    doc.text("In Words:", PADDING + 2, textY);
    doc.setFont("Inter-Regular", "normal");
    const words = isViewData?.amountinwords || "Zero Rupees Only";
    doc.text(words, PADDING + 15, textY, {
      maxWidth: totalLabelX - PADDING - 17,
    });

    doc.setFont("Inter-Bold", "bold");
    doc.text("TOTAL", totalLabelX + 2, textY);
    doc.text(`₹${globalData?.grandtotal}`, MARGIN_RIGHT - 2, textY, {
      align: "right",
    });

    // --- 3. THE "SAME LINE" SECTION (Signature Left, Taxes Right) ---
    let currentTaxY = finalY + rowH; // This is the shared starting line
    const taxRowsCount = isInterState ? 1 : 2;
    const sigSectionHeight = 15; // Total height for this area
    const totalHeight = Math.max(sigSectionHeight, taxRowsCount * rowH);
    if (isInterState) {
      doc.rect(totalLabelX, currentTaxY, rightSectionWidth, rowH);
      doc.line(totalValueX, currentTaxY, totalValueX, currentTaxY + rowH);
      doc.setFont("Inter-Bold", "bold");
      doc.text("IGST", totalLabelX + 2, currentTaxY + 3.5);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        `₹${globalData?.igstamount || 0}`,
        MARGIN_RIGHT - 2,
        currentTaxY + 3.5,
        { align: "right" }
      );
    } else {
      // CGST Row
      doc.rect(totalLabelX, currentTaxY, rightSectionWidth, rowH);
      doc.line(totalValueX, currentTaxY, totalValueX, currentTaxY + rowH);
      doc.setFont("Inter-Regular", "normal");
      doc.text("CGST", totalLabelX + 2, currentTaxY + 3.5);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        `₹${globalData?.cgstamount || 0}`,
        MARGIN_RIGHT - 2,
        currentTaxY + 3.5,
        { align: "right" }
      );

      // SGST Row (Directly below CGST)
      doc.rect(totalLabelX, currentTaxY + rowH, rightSectionWidth, rowH);
      doc.line(
        totalValueX,
        currentTaxY + rowH,
        totalValueX,
        currentTaxY + rowH * 2
      );
      doc.setFont("Inter-Regular", "normal");
      doc.text("SGST", totalLabelX + 2, currentTaxY + rowH + 3.5);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        `₹${globalData?.sgstamount || 0}`,
        MARGIN_RIGHT - 2,
        currentTaxY + rowH + 3.5,
        { align: "right" }
      );
    }
    let sigBottomY = currentTaxY + totalHeight - 2;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const ratio = Math.min(25 / width, 8 / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(base64, "PNG", PADDING, sigBottomY - imgH - 4, imgW, imgH);
      } catch (e) {
        console.warn("Signature failed", e);
      }
    } else {
      sigBottomY = currentTaxY + totalHeight - 3;
    }

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(6);
    sigBottomY -= 1;
    doc.text("Authorised Signature", PADDING + 2, sigBottomY);
    if (storeSettings?.negobillBranding) {
      const minGapY = y + 3;
      const bottomLimitY = HALF_PAGE_HEIGHT - 5;
      let finalBrandingY = Math.max(minGapY, bottomLimitY);
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";
      doc.setFontSize(8);
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);
      doc.text(normalText, MARGIN_LEFT, finalBrandingY);
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, MARGIN_LEFT + normalW, finalBrandingY);
    }
    return doc;
  };

  const generateBillHalfA4PDF = async () => {};
  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBillHalfA4PDF();
    } else {
      doc = await generateinvoiceHalfA4PDF();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generateBillHalfA4PDF();
      } else {
        doc = await generateinvoiceHalfA4PDF();
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle")
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
    // finally {
    //   setPrint(false);
    // }
  };

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  const formatCurrency2 = (value) => {
    const amount = CurrencyConverter.toCurrency(value, "INR");
    const formatted = Math.abs(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 0, // Don't force .00
      maximumFractionDigits: 2, // Show up to 2 decimals if they exist (like .78)
    });

    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);
  const grantotal = globalData?.grandtotal;
  const paidamount = globalData?.paidamount;
  const balanceDue = grantotal - paidamount;
  useEffect(() => {
    const upi = storeSettings?.paymentSettings?.upiId;

    const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
    console.log("ip", upiUrl);
    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [
    storeSettings?.paymentSettings?.upiId,
    storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
  ]);
  const isInterState =
    globalData?.salefrom?.statecode &&
    globalData?.saleto?.statecode &&
    globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;

  return (
    <>
      <div className="invoice-scale">
        {selectedSize === "INVOICE" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in" style={{ padding: "20px" }}>
                  <div style={{ display: "flex", paddingBottom: "10px" }}>
                    <div style={{ flex: "1" }}>
                      <div>
                        {("/assets/images/logo-light.png" ||
                          settings?.saleProfileData?.image) && (
                          <img
                            src={
                              settings?.saleProfileData?.image
                                ? uRLs.IMAGE_URL +
                                  "profile/" +
                                  settings?.saleProfileData?.image
                                : "/assets/images/logo-light.png"
                            }
                            className="img-rounded logo"
                            height="50"
                            alt="Logo"
                          />
                        )}
                      </div>

                      <div className="font-14">
                        {settings?.saleProfileData?.addressline1}
                      </div>
                      <div className="font-14">
                        {settings?.saleProfileData?.addressline2}{" "}
                        {settings?.saleProfileData?.pincode || ""}
                      </div>
                      <div className="font-13">
                        <span className="fw-bold">Ph:</span>{" "}
                        {settings?.saleProfileData?.phone}{" "}
                        <span className="fw-bold">GSTIN:</span>{" "}
                        {settings?.saleProfileData?.gstnumber}
                      </div>
                    </div>

                    <div style={{ flex: "2", textAlign: "center" }}>
                      <div style={{ fontSize: "20px", color: "#555" }}>
                        TAX INVOICE
                      </div>
                      <div
                        style={{
                          fontSize: "28px",
                          marginTop: "5px",
                          fontWeight: "800",
                          textTransform: "uppercase",
                          lineHeight: "1",
                        }}
                      >
                        {settings?.saleProfileData?.title || "COMPANY NAME"}
                      </div>
                    </div>

                    <div style={{ flex: "1", textAlign: "right" }}>
                      <div
                        style={{ display: "inline-block", textAlign: "right" }}
                      >
                        <div
                          className=" font-13"
                          style={{
                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            marginBottom: "5px",
                          }}
                        >
                          Invoice No.
                          <span className="fw-bold"> {globalData?.saleno}</span>
                        </div>
                        <div className="d-flex justify-content-end font-13">
                          {/* <span>DATE: {saleTime?.date}</span> */}
                          <span> DATE: {saleTime?.date}</span>
                          <span className="ms-3">TIME:{saleTime?.time}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="d-flex "
                    style={{
                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                    }}
                  >
                    <div
                      style={{
                        flex: "1",
                        padding: "5px",
                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                      }}
                    >
                      <span className="fw-bold font-14">
                        Customer Details :
                      </span>
                      <div className="font-14 ">{globalData?.saleto?.name}</div>
                      <div className="font-14">
                        {" "}
                        {globalData?.saleto?.addressline1 &&
                          `${globalData?.saleto?.addressline1}, `}
                        {globalData?.saleto?.addressline2 &&
                          `${globalData?.saleto?.addressline2}, `}
                        {globalData?.saleto?.district &&
                          `${globalData?.saleto?.district}, `}
                        {globalData?.saleto?.pincode &&
                          ` - ${globalData?.saleto?.pincode}`}
                      </div>
                    </div>
                    <div
                      style={{
                        width: "320px",
                        padding: "5px",
                        WebkitFontSmoothing: "antialiased",
                        textRendering: "optimizeLegibility",
                      }}
                    >
                      <div className="font-14">
                        <span className="fw-bold">Ph:</span>{" "}
                        {globalData?.saleto?.phone || ""}
                      </div>
                      <div className=" font-14">
                        {" "}
                        <span className="fw-bold">GSTIN:</span>{" "}
                        {globalData?.saleto?.gstnumber || ""}
                      </div>
                    </div>
                  </div>
                  <table
                    width="100%"
                    className="mt-0"
                    style={{ borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr className=" fw-bold">
                        <th
                          className="force-style"
                          style={{
                            width: "40px",

                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                        >
                          {" "}
                          #
                        </th>
                        <th
                          className="force-style"
                          style={{
                            textAlign: "left",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                        >
                          ITEM
                        </th>

                        <th
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                        >
                          RATE
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "60px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                        >
                          QTY
                        </th>
                        <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          LANDING COST
                        </th>
                        <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          TAX VAL
                        </th>
                        <th
                          // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          AMOUNT
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {globalData?.saleitems?.map((item, index) => (
                        <tr
                          key={index}
                          className="font-13"
                          style={{ height: "30px" }}
                        >
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,

                              textAlign: "center",
                              borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              padding: "0 5px",
                            }}
                          >
                            {item?.title}
                          </td>

                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px",
                            }}
                          >
                            ₹{item?.baseprice}
                          </td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {item?.quantity} $
                            {(() => {
                              const unitCode = item?.isSecondaryUnit
                                ? item?.unitConfig?.secondaryUnitCode
                                : item?.unitConfig?.primaryUnitCode;
                              return unitCode || "";
                            })()}
                          </td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            ₹{item?.lineTotalLandingCost}
                          </td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            ₹{item?.lineTotalBasePrice}
                          </td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              paddingRight: "5px",
                            }}
                          >
                            ₹{item?.lineGrandTotal}
                          </td>
                        </tr>
                      ))}

                      {[
                        ...Array(
                          Math.max(0, 5 - (globalData?.saleitems?.length || 0))
                        ),
                      ].map((_, i) => (
                        <tr key={`empty-${i}`} style={{ height: "50px" }}>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      {/* Row 1: In Words & Total */}
                      <tr className="font-13">
                        <td
                          colSpan="2"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "left",
                            padding: "5px",
                          }}
                        >
                          <span className="fw-bold">In Words:</span>{" "}
                          {globalData?.amountinwords}
                        </td>
                        <td
                          colSpan="4"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            padding: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          TOTAL
                        </td>
                        <td
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            padding: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          ₹{globalData?.grandtotal}
                        </td>
                      </tr>
                      <tr className="font-13">
                        <td
                          colSpan="2"
                          rowSpan={isInterState ? 1 : 2}
                          style={{
                            textAlign: "left",
                            padding: "5px",
                            verticalAlign: "bottom",
                          }}
                        >
                          <div className="font-13 mt-2">
                            {storeSettings?.invoiceSettings?.signature ? (
                              <img
                                src={
                                  uRLs.IMAGE_URL +
                                  storeSettings?.invoiceSettings?.signature
                                }
                                alt="Signature"
                                width="120"
                                style={{ marginBottom: "-5px" }}
                              />
                            ) : (
                              <div className="pt-4"></div>
                            )}
                            <div style={{ paddingTop: "5px" }}>
                              Authorised Signature
                            </div>
                          </div>
                        </td>

                        {isInterState ? (
                          <>
                            <td
                              colSpan="4"
                              style={{
                                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                textAlign: "right",
                                padding: "5px",
                              }}
                            >
                              IGST
                            </td>
                            <td
                              style={{
                                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                textAlign: "right",
                                padding: "5px",
                              }}
                            >
                              ₹{globalData?.igstamount || 0}
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              colSpan="4"
                              style={{
                                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                textAlign: "right",
                                padding: "5px",
                              }}
                            >
                              CGST
                            </td>
                            <td
                              style={{
                                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                textAlign: "right",
                                padding: "5px",
                              }}
                            >
                              ₹{globalData?.cgstamount || 0}
                            </td>
                          </>
                        )}
                      </tr>

                      {!isInterState && (
                        <tr className="font-13">
                          <td
                            colSpan="4"
                            style={{
                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              padding: "5px",
                            }}
                          >
                            SGST
                          </td>
                          <td
                            style={{
                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                              padding: "5px",
                            }}
                          >
                            ₹{globalData?.sgstamount || 0}
                          </td>
                        </tr>
                      )}
                    </tfoot>
                    {/* <tfoot>
                          <tr className="font-13">
                            <td colSpan="2" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "left", padding: "5px",  }}><span className="fw-bold">In Words:</span> {isViewData?.amountinwords}</td>
                            <td colSpan="3" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "right", padding: "5px", fontWeight: "bold" }}>Total</td>
                            <td style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "right", padding: "5px", fontWeight: "bold" }}>₹{globalData?.grandtotal}</td>
                          </tr>  
                          <tr className="font-13">
                            <td colSpan="2" style={{ border: `0px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "left", padding: "5px",  }}>   <div
                      className="font-13 mt-1"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {(globalData?.cashamount || 0) - (globalData?.cashchange || 0) > 0 && (
                        <div className="font-13 " style={{ width: "50%" }}>
                          <b  className="me-1">₹{globalData?.cashPaid}</b> Paid Via Cash
                        </div>
                      )}

                      {(globalData?.cardamount || 0) - (globalData?.cardchange || 0) > 0 && (
                        <div className="font-13 " style={{ width: "50%" }}>
                          <b className="me-1">₹{globalData?.cardPaid}</b> {" "} Paid Via Card
                        </div>
                      )}

                        {(globalData?.upiamount || 0) -
                                                                (globalData?.upichange || 0) >
                                                                0 && (
                        <div className="font-13 "  style={{ width: "50%" }}>
                          <b  className="me-1">₹{globalData?.upiPaid}</b> Paid Via UPI
                        </div>
                      )}

                      {(globalData?.onlinechange || 0) >
                                                                0 && (
                        <div className="font-13 " style={{ width: "50%" }}>
                          <b  className="me-1">₹{globalData?.onlinePaid}</b> {" "} Paid Via Online
                        </div>
                      )}
                    </div></td>
                            <td colSpan="5" className="p-2" style={{ border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "center", padding: "5px", fontWeight: "bold" }}>     <div className="pe-1">
                                                        {storeSettings?.invoiceSettings
                                                          ?.signature ? (
                                                          <img
                                                            src={
                                                              uRLs.IMAGE_URL +
                                                              storeSettings?.invoiceSettings
                                                                ?.signature
                                                            }
                                                            alt="Signature"
                                                            width="120"
                                                            style={{ marginBottom: "-5px" }} // Slight overlap fix if needed
                                                          />
                                                        ) : (
                                                          <>
                                                            <div className="pt-4"></div>
                                                          </>
                                                        )}
                                                        <div style={{  paddingTop: "5px" }}>Authorised Signature</div>
                                                      </div></td>
                          
                          </tr>   

                        </tfoot> */}
                  </table>

                  {storeSettings?.negobillBranding && (
                    <>
                      <div className="mt-5 font-13 d-flex justify-content-left ">
                        <span>
                          Powered By{" "}
                          <span className="fw-bold">NegoBill.com</span>
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : selectedSize === "BILL" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1"></div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      <div
        className="modal-footer d-block mt-2"
        style={{
          position: "sticky",
          bottom: -4,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {payment && <div className="fw-600 mb-2 font-14">PAYMENT SUMMARY</div>}
        {payment && (
          <table
            className="items table-bordered mb-3"
            width="100%"
            cellPadding="4"
          >
            <tbody className="text-center">
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor: isViewData.cashamount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                  }}
                  onClick={(e) => {
                    if (isViewData.cashamount > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.cashamount > 0
                        ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px", fontSize: "12px" }}
                  >
                    CASH
                    {isViewData?.cashamount > 0 && <ShowIcon/>}
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  CARD
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  ONLINE
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  UPI
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor:
                      isViewData?.paylateramount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => {
                    if (isViewData?.paylateramount > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.paylateramount > 0
                        ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px" }}
                  >
                    PAYLATER
                    {isViewData?.paylateramount > 0 && (
                      <ShowIcon iClass={"ms-1"}/>
                    )}
                  </div>
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cashamount || 0) -
                      (isViewData?.cashchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cardamount || 0) -
                      (isViewData?.cardchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.onlineamount || 0) -
                      (isViewData?.onlinechange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.upiamount || 0) - (isViewData?.upichange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.paylateramount || 0) -
                      (isViewData?.paylaterchange || 0)
                  )}
                </td>
              </tr>
            </tbody>
            <CashButton
              ref={cashRef}
              trackId={isViewData?.boxCashInfo?.trackid}
              trackMode={isViewData?.boxCashInfo?.trackmode}
            />
            <PayLaterButton
              ref={paylaterRef}
              trackId={isViewData?.paylaterInfo?.trackid}
              customerId={isViewData?.paylaterInfo?.customerid}
              trackMode={isViewData?.paylaterInfo?.trackmode}
            />
          </table>
        )}
        {downloadbtn && (
          <div className="my-2 d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={18} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default HalfA4_3;
